module.exports = __webpack_public_path__ + "img/CT-horizontalni_boja_negativ.1a6db95.svg";